<template>
  <div class="row">
    <div class="col-lg-6 m-auto">
      <v-img
        max-height="220"
        max-width="400"
        contain
        class="mx-auto mb-4"
        :src="logo"
      />
      <card :title="$t('reset_password')">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-col cols="12">
            <v-text-field
              :value="form.email"
              label="Correo electrónico"
              filled
              readonly
            />
          </v-col>
          <v-col cols="12">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.password"
                  :type="show ? 'text' : 'password'"
                  name="password"
                  label="Contraseña"
                  placeholder=""
                  :append-icon="show ? 'fa-eye' : 'fa-eye-slash'"
                  counter
                  maxlength="20"
                  :color="bgColor"
                  :rules="[rules.required, rules.format, rules.minLength, rules.maxLength, passwordConfirmationRule]"
                  v-on="on"
                  @click:append="show = !show"
                />
              </template>
              <span>
                La contraseña debe contener las siguientes características:<br>
                Longitud de 8 a 20 caracteres<br>
                Un caracter especial (!@#$&*_.-)<br>
                Un número<br>
                Una letra en mayúsculas<br>
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.password_confirmation"
              :type="confirmationShow ? 'text' : 'password'"
              name="password_confirmation"
              label="Confirmar contraseña"
              placeholder=""
              :append-icon="confirmationShow ? 'fa-eye' : 'fa-eye-slash'"
              counter
              maxlength="20"
              :color="bgColor"
              :rules="[rules.required, rules.format, rules.minLength, rules.maxLength, passwordConfirmationRule]"
              @click:append="confirmationShow = !confirmationShow"
            />
          </v-col>
          <v-col cols="12">
            <v-btn
              :loading="form.busy"
              :disabled="!valid || form.busy"
              class="mr-4 white--text"
              :color="bgColor"
              block
              @click="validate"
            >
              {{ $t('update') }}
            </v-btn>
          </v-col>
        </v-form>
      </card>
    </div>
  </div>
</template>

<script>
import Form from 'vform';
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, { siteKey: '6LeZYgUcAAAAAJJQhWBIy4-_1FkifSd0Vo-M49VQ' });

export default {
  middleware: 'guest',
  layout: 'auth',
  metaInfo() {
    return { title: this.$t('reset_password') };
  },
  data: () => ({
    form: new Form({
      token: '',
      email: '',
      password: '',
      password_confirmation: '',
      busy: false,
    }),
    recaptchaVerified: false,
    show: false,
    confirmationShow: false,
    rules: {
      required: (v) => !!v || 'La contraseña es requerida',
      format: (v) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*_.-])/.test(v) || 'La contraseña no es lo suficientemente segura',
      minLength: (v) => v.length > 8 || 'La contraseña es muy corta',
      maxLength: (v) => v.length < 20 || 'La contraseña es muy larga',
    },
    valid: false,
    apiURL: '/api/password/reset',
    method: 'POST',
    logo: '/img/logo_hka.png',
  }),

  computed: {
    passwordConfirmationRule() {
      return this.form.password === this.form.password_confirmation || 'Las contraseñas deben coincidir';
    },
    isEbipac() {
      const env = process.env.VUE_APP_ENV;
      return env === 'EBI' || env === 'ebipac';
    },
    bgColor() {
      return this.isEbipac ? '#0A3D91' : '#0084CA';
    },
  },

  created() {
    this.form.email = this.$route.query.email;
    this.form.token = this.$route.params.token;
  },

  mounted() {
    const url = window.location;
    if (this.isEbipac || url.href.includes('ebi-pac')) {
      this.logo = '/img/ebi-pac.png';
    }
  },

  methods: {
    async reset() {
      window.axios({
        method: this.method,
        url: this.apiURL,
        data: this.form,
      }).then((result) => {
        this.form.busy = true;
        this.$store.dispatch('notifications/show', {
          message: result.data.status,
          type: 'success',
        });
        this.login();
      }).catch(() => {
        this.form.busy = false;
      });
    },

    async login() {
      const { data } = await window.axios.post('/api/login', {
        email: this.form.email,
        password: this.form.password,
        type: 'D',
      }).catch((error) => {
        if (error.response) {
          // Request made and server responded
          const errors = Object.values(error.response.data.errors);
          errors.forEach((element) => {
            this.errores += element;
          });
        } else if (error.request) {
          // The request was made but no response was received
          this.errores = 'Ocurrió un error en la comunicación con el servidor.';
        } else {
          // Something happened in setting up the request that triggered an Error
          this.errores = 'Ocurrió un error en la comunicación con el servidor.';
        }
      });

      // Save the token.
      this.$store.dispatch('auth/saveToken', {
        token: data.token,
        remember: true,
      });

      // Fetch the user.
      await this.$store.dispatch('auth/fetchUser');
      this.busy = false;
      this.$refs.form.reset();

      this.$router.push({ name: 'home' });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.reset();
      }
    },
    markRecaptchaAsVerified() {
      this.pleaseTickRecaptchaMessage = '';
      this.recaptchaVerified = true;
    },
  },
};
</script>
<style scoped>
.text-center {
  text-align: center;
}

.g-recaptcha {
  display: inline-block;
}
</style>
